import store from '../store';

const success = (response) => response;

const error = async (err) => {
	switch (err.response.status) {
		case 401:
			// auto logout
			await store.dispatch('auth/logout');
			await store.dispatch('me/clear');

			// show toast
			store.dispatch('toast/showToast', {
				header: 'Session timeout',
				content: 'Your session was timeout, Please try to login again.',
				type: 'danger',
				timeout: 2000,
				onClose: () => {
					// when toast hide, redirect to login pages
					window.location = '/login';
				},
			});
			break;
		case 403:
			window.location = '/profile?password-expired';
			break;
		case 500:
			// handle code
			break;
		default:
	}

	return Promise.reject(err);
};

export default {
	success,
	error,
};